var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "buttons-contianer" },
    [
      _c("v-btn", { staticClass: "primary-button", attrs: { small: "" } }, [
        _vm._v("NUEVO JEFE")
      ]),
      _c(
        "v-btn",
        { staticClass: "primary-button disabled", attrs: { small: "" } },
        [_vm._v("NUEVO JEFE")]
      ),
      _c(
        "v-btn",
        { staticClass: "primary-button", attrs: { small: "" } },
        [
          _vm._v("NUEVO JEFE"),
          _c("v-icon", { attrs: { right: "", dark: "" } }, [
            _vm._v("cloud_upload")
          ])
        ],
        1
      ),
      _c(
        "v-btn",
        { staticClass: "primary-button disabled", attrs: { small: "" } },
        [
          _vm._v("NUEVO JEFE"),
          _c("v-icon", { attrs: { right: "", dark: "" } }, [
            _vm._v("cloud_upload")
          ])
        ],
        1
      ),
      _c(
        "v-btn",
        { staticClass: "primary-button blue", attrs: { small: "" } },
        [_vm._v("NUEVO JEFE ")]
      ),
      _c(
        "v-btn",
        { staticClass: "primary-button blue disabled", attrs: { small: "" } },
        [_vm._v("NUEVO JEFE ")]
      ),
      _c(
        "v-btn",
        { staticClass: "primary-button text", attrs: { small: "" } },
        [_vm._v("cancelar")]
      ),
      _c(
        "v-btn",
        { staticClass: "primary-button text disabled", attrs: { small: "" } },
        [_vm._v("cancelar")]
      ),
      _c(
        "v-btn",
        { staticClass: "primary-button text line", attrs: { small: "" } },
        [_vm._v("opciones")]
      ),
      _c(
        "v-btn",
        {
          staticClass: "primary-button text line disabled",
          attrs: { small: "" }
        },
        [_vm._v("opciones")]
      ),
      _c(
        "v-btn",
        {
          staticClass: "primary-button text black capitalize",
          attrs: { small: "" }
        },
        [_vm._v("cancelar")]
      ),
      _c(
        "v-btn",
        {
          staticClass: "primary-button text black disabled",
          attrs: { small: "" }
        },
        [_vm._v("cancelar")]
      ),
      _c(
        "v-btn",
        { staticClass: "primary-button text black", attrs: { small: "" } },
        [
          _vm._v("COBRAR"),
          _c("v-icon", { attrs: { right: "", dark: "" } }, [
            _vm._v("cloud_upload")
          ])
        ],
        1
      ),
      _c(
        "v-btn",
        {
          staticClass: "primary-button text black disabled",
          attrs: { small: "" }
        },
        [
          _vm._v("COBRAR"),
          _c("v-icon", { attrs: { right: "", dark: "" } }, [
            _vm._v("cloud_upload")
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b7516ba6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b7516ba6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/buttons.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-b7516ba6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/buttons.vue
// module chunks = 26